import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { ConfirmationNumber, CheckCircle, Payments, AccountBalanceWallet } from "@mui/icons-material";
import { orange, blue, purple, green } from "@mui/material/colors";
import { formatCurrency } from "../../../utils/formatCurrency";
import { useGetAffiliateStatsQuery } from "../../../store/services/admin/admin.service";
import { StatWrapper } from "./styles";

const AffiliateOverview = () => {
	const { data, isLoading } = useGetAffiliateStatsQuery({});

	const statCards = [
		{
			label: "Total Coupons",
			value: (data?.totalCoupons ?? 0).toLocaleString(),
			icon: <ConfirmationNumber />,
			color: orange[500],
			sub: "Affiliate coupons created"
		},
		{
			label: "Active Coupons",
			value: (data?.totalActiveCoupons ?? 0).toLocaleString(),
			icon: <CheckCircle />,
			color: blue[500],
			sub: "Approved and usable"
		},
		{
			label: "Total Sales",
			value: formatCurrency(data?.totalSales ?? 0, "EGP"),
			icon: <Payments />,
			color: purple[500],
			sub: "All-time sales via coupons"
		},
		{
			label: "Commission Owed",
			value: formatCurrency(data?.totalCommission ?? 0, "EGP"),
			icon: <AccountBalanceWallet />,
			color: green[600],
			sub: "All-time, across all users"
		}
	];

	return (
		<Box display={"flex"} flexWrap={"wrap"} gap={2}>
			{isLoading
				? [1, 2, 3, 4].map(i => <Skeleton key={i} variant={"rounded"} height={92} sx={{ flex: 1, minWidth: 185 }} />)
				: statCards.map((card, i) => (
						<StatWrapper key={i} $statColor={card.color}>
							<Box className={"icon"}>{card.icon}</Box>
							<Box className={"stats"}>
								<Typography fontWeight={800} variant={"h5"} lineHeight={1.1}>
									{card.value}
								</Typography>
								<Typography fontWeight={600} fontSize={13} mt={0.3}>
									{card.label}
								</Typography>
								<Typography color={"textSecondary"} fontSize={11} mt={0.25}>
									{card.sub}
								</Typography>
							</Box>
						</StatWrapper>
					))}
		</Box>
	);
};

export default AffiliateOverview;
